module.exports = __webpack_public_path__ + "static/snowcamp-1fa21ff57a52ae77462a68668c62a2e3.png";